import axiosTokenInstance from '../../Instances/axiosTokenInstance';
import { toast } from 'react-toastify';
import _ from 'lodash'

export const actions = {
    CREDIT_RATING_LOADING: 'CREDIT_RATING_LOADING',
    CREDIT_RATING_CLEAR_LOADING: 'CREDIT_RATING_CLEAR_LOADING',
    OVERLAY_RATING_LOADING: 'OVERLAY_RATING_LOADING',
    OVERLAY_RATING_CLEAR_LOADING: 'OVERLAY_RATING_CLEAR_LOADING',
    CREDIT_RATING_ERROR: 'CREDIT_RATING_ERROR',
    RATING_ERROR: 'RATING_ERROR',
    COMPANY_RATING_FETCHED: 'COMPANY_RATING_FETCHED',
    PERSON_RATING_FETCHED: 'PERSON_RATING_FETCHED',
    RATING_INFO_FETCHED: 'RATING_INFO_FETCHED',
    CREDIT_RATING_TERMS_FETCHED: 'CREDIT_RATING_TERMS_FETCHED',
    TERMS_ACCEPTED_SUCCESSFULLY: 'TERMS_ACCEPTED_SUCCESSFULLY',
    UPDATE_DEBTOR_RATING: 'UPDATE_DEBTOR_RATING',
    CREDIT_RATING_FILTERED: 'CREDIT_RATING_FILTERED',
    CREDIT_RATING_DATA_CLEAR: 'CREDIT_RATING_DATA_CLEAR',
    CREDIT_RATING_DATA_CLEAR_RATING: 'CREDIT_RATING_DATA_CLEAR_RATING',
    CREDIT_RATING_SET_SOKEVERDI: 'CREDIT_RATING_SET_SOKEVERDI'
    }

export const displayForms = {
    CREDITRATING: 'CREDITRATING',
    NOCREDITRATING: 'CREDITRATING'
}

const getErrorMessage = (err) => {
    if (_.has(err, 'response.data.title')) {
        return err.response.data.title
    }
    else if (_.has(err, 'response.statusText')) {
        return err.response.statusText
    }
    else if (_.has(err, 'response.data')) {
        return err.response.data
    } else {
        return err.message.toString()
    }
}

const setSearchType = (searchType) => {
    if (searchType === 'NORMAL' || searchType === 'NORMAL_V3' || searchType === 'KF_PRIV' || searchType === 'NORMAL_V4') {
        return 'Privat';
    } else if (searchType === 'EXTENDED' || searchType === 'EXTENDED_V3' || searchType === 'KF_ORG' || searchType === 'EXTENDED_V4') {
        return 'Næring';
    }
    return searchType;
};

const checkVersion = (searchType) => {
    if (searchType === 'NORMAL_V3' || searchType === 'EXTENDED_V3') {
        return '3.0';
    } else if (searchType === 'NORMAL_V4' || searchType === 'EXTENDED_V4') {
        return '4.0';
    } else {
        return '2.0';
    }
};

const setAction = (action) => {
    if (action === 'CREDIT_RATING_PARTNER') {
        return 'Kredittsjekk';
    } else if (action === 'ACCEPT_BISLAB_TERMS') {
        return 'Signerte avtale';
    } else if (action === 'DISABLE_BISLAB') {
        return 'Deaktiverte Kredittvurdering';
    }
    return action;
};

const formatDate = d => {
    if ((d) && (d.length >= 20)) {
        return `${d.substring(8, 10)}.${d.substring(5, 7)}.${d.substring(0, 4)}`
    }
    return '-'
}

const formatBirthDate = (d) => {
    if (d) {
        return d.replace(/-/g, '.');
    }
    return '-';
};

const formatNumber = (num) => {
    if (num === null || num === undefined || num === '') {
        return '-';
    } else if (num === 0 || num === '0') {
        return '0';
    }
    return num;
};

function formatName(name, locale = 'nb-NO') {
  if (!name) return '';

  // whitespace
  const original = String(name).replace(/\s+/g, ' ').trim();
  if (!original) return '';

  const partsOrig = original.split(' ');
  const parts = original.toLocaleLowerCase(locale).split(' ');

  const particles = new Set([
    'av','von','van','de','del','da','der','di','la','le','du','den','af',
    'og','i','på','til'
  ]);

  const isRoman = (w) => /^[MDCLXVI]+$/.test(w);
  const capSeg = (seg) =>
    seg ? seg.charAt(0).toLocaleUpperCase(locale) + seg.slice(1) : seg;

  const capWordWithDelims = (w) =>
    // Capitalize around hyphens and apostrophes
    w.split(/([-'’])/).map(t => (/^[-'’]$/.test(t) ? t : capSeg(t))).join('');

  const out = parts.map((word, i) => {
    const orig = partsOrig[i];

    if (isRoman(orig)) return orig;

    // Suffixes
    if (/^jr\.?$/i.test(orig)) return 'Jr.';
    if (/^sr\.?$/i.test(orig)) return 'Sr.';

    // Initials like "J.", "R.", or "J.R.R." → keep uppercase
    if (/^[A-Z]\.?$/i.test(orig) || /^[A-Z](\.[A-Z])+\.?$/i.test(orig)) {
      return orig.toUpperCase();
    }

    // Lowercase common particles unless they are the first word
    if (i > 0 && particles.has(word)) return word;

    // Regular word (handles O'Brien, Anne-Marie, etc.)
    return capWordWithDelims(word);
  });

  return out.join(' ');
}


const boolToText = (value) => (value ? 'Ja' : 'Nei');

const checkString = (value) => {
    if (value === undefined || value === null || value === '') {
      return '-'
    }
    return value.toString();
};

const formatRolletype = (value) => {
    switch (value) {
        case undefined:
        case null:
        case '':
          return '-';
        case 'MEDL':
          return 'Styremedlem';
        case 'LEDE':
          return 'Styreleder';
        case 'DAGL':
          return 'Daglig leder';
        default:
          return value.toString();
      }
}

const formatNumberWithSpaces = (num) => {
    if (num === null || num === undefined || num === '') {
        return '-';
    } else if (num === 0 || num === '0') {
        return '0';
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

function formatYMDtoDMY(ymd) {
  if (typeof ymd !== 'string') return '-';
  const parts = ymd.split('-');
  if (parts.length !== 3) return '-';
  let [year, month, day] = parts;
  if (day.length === 1)   day = '0' + day;
  if (month.length === 1) month = '0' + month;
  if (!/^\d{4}$/.test(year) || !/^\d{2}$/.test(month) || !/^\d{2}$/.test(day)) {
    return '-';
  }
  return `${day}.${month}.${year}`;
}

const percentFormatter = new Intl.NumberFormat('nb-NO', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

function convertBooleansInObjectArray(objArray) {
    return objArray.map(item => {
      Object.keys(item).forEach(key => {
        if (typeof item[key] === 'boolean') {
          item[key] = boolToText(item[key]);
        }
      });
      return item;
    });
  }

  function convertRolletypeInObjectArray(objArray) {
    return objArray.map(item => {
      Object.keys(item).forEach(key => {
          item[key] = formatRolletype(item[key]);
        
      });
      return item;
    });
  }
  
  function processParsedJsonToBool(parsedJson) {
    if (parsedJson.roller && Array.isArray(parsedJson.roller)) {
      parsedJson.roller = convertBooleansInObjectArray(parsedJson.roller);
      parsedJson.roller = convertRolletypeInObjectArray(parsedJson.roller);
    }
    if (parsedJson.regnskap && Array.isArray(parsedJson.regnskap)) {
        parsedJson.regnskap = convertBooleansInObjectArray(parsedJson.regnskap);
    }
    return parsedJson;
  }

  const mapCompanyRating = (companyRatingObject, orgNo) => {
    if (!companyRatingObject) return null;

    const arr = Array.isArray(companyRatingObject) ? companyRatingObject : [companyRatingObject];

    return arr.map((e, i) => {

        const oi = e.organisationInformation || {};
        const addr = oi.businessAddress || {};

        const mappedIndustries = (oi.industries || []).map((item, idx) => ({
            j:           idx,
            description: checkString(item.description),
            naceCode:    checkString(item.naceCode),
            primaryCode: boolToText(item.primaryCode)
        }));
   
        const organisationInformation = {
            organisationName:        checkString(oi.organisationName),
            organisationForm:        checkString(oi.organisationForm),
            status:                  checkString(oi.status),
            creditFreeze:            boolToText(oi.creditFreeze),
            statusDate:              formatYMDtoDMY(oi.statusDate),
            numberOfEmployees:       formatNumberWithSpaces(oi.numberOfEmployees),
            establishmentDate:       formatYMDtoDMY(oi.establishmentDate),
            businessAddress:         oi.businessAddress 
            ? {
                municipalityName:    checkString(addr.municipalityName),
                municipalityNumber:  checkString(addr.municipalityNumber),
                zipCode:             checkString(addr.zipCode),
                postalArea:          checkString(addr.postalArea),
                street:              checkString(addr.street),
            } : {},
            postalAddress:           oi.postalAddress 
            ? {
                municipalityName:    checkString(addr.municipalityName),
                municipalityNumber:  checkString(addr.municipalityNumber),
                zipCode:             checkString(addr.zipCode),
                postalArea:          checkString(addr.postalArea),
                street:              checkString(addr.street),
            } : {},
            industries:              mappedIndustries
        }

        // risk inneholder legalRecords som inneholder paymentRemarks, movableAssets, propertyForeclosures og propertyEnforcedActionRemarks
        const ri = e.risk || {};
        const su = ri.summary || {};
        const risk = {
            debtCollectionScore:    formatNumber(ri.debtCollectionScore),
            normalisedScore:        formatNumber(ri.normalisedScore),
            scoreRating:            checkString(ri.scoreRating),
            scoreRatingExplanation: checkString(ri.scoreRatingExplanation),
            rawScore:               formatNumber(ri.rawScore),
            probabilityOfDefault:   percentFormatter.format(ri.probabilityOfDefault),
            creditLimit:            formatNumberWithSpaces(ri.creditLimit),
            summary: ri.summary
                ? {
                    ownsVehicle:                     boolToText(su.ownsVehicle),
                    ownsProperty:                    boolToText(su.ownsProperty),
                    paymentRemarksCount:             formatNumber(su.paymentRemarksCount),
                    paymentRemarksAmount:            formatNumber(su.paymentRemarksAmount),
                    assetSeizureCount:               formatNumber(su.assetSeizureCount),
                    assetSeizureAmount:              formatNumber(su.assetSeizureAmount),
                    propertyForeclosureCount:        formatNumber(su.propertyForeclosureCount),
                    propertyForeclosureAmount:       formatNumber(su.propertyForeclosureAmount),
                    forcedPropertySaleDecidedCount:  formatNumber(su.forcedPropertySaleDecidedCount),
                    arrestCount:                     formatNumber(su.arrestCount),
                    arrestAmount:                    formatNumber(su.arrestAmount),
                    noAssetsForSeizureCount:         formatNumber(su.noAssetsForSeizureCount),
                } : {}
        }

        const lr = ri.legalRecords || {};
        const paymentRemarks = (lr.paymentRemarks || []).map((item, idx) => ({
            j:                idx,
            creditor:         checkString(item.creditor),
            caseNumber:       checkString(item.caseNumber),
            registrationDate: formatYMDtoDMY(item.registrationDate),
            settlementStatus: checkString(item.settlementStatus),
            settlementDate:   formatYMDtoDMY(item.settlementDate),
            collectionAgency: checkString(item.collectionAgency),
            typeCode:         checkString(item.typeCode),
            typeDescription:  checkString(item.typeDescription),
            caseEventType:    checkString(item.caseEventType),
            amount:           formatNumberWithSpaces(item.amount),
        }));

        const movableAssets = (lr.movableAssets || []).map((item, idx) => {
            const mappedRoles = (item.roles || []).map((rItem, rIdx) => ({
                j:           rIdx,
                code:        checkString(rItem.code),
                description: checkString(rItem.description),
                roleHolder:  rItem.roleHolder
                    ? {
                        type:           checkString(rItem.roleHolder.type),
                        organisationId: checkString(rItem.roleHolder.organisationId),
                        name:           checkString(rItem.roleHolder.name),
                    } : {}
            }));

            return {
                j:                         idx,
                documentNumber:            checkString(item.documentNumber),
                enforced:                  boolToText(item.enforced),
                expiryDateLegalProtection: formatYMDtoDMY(item.expiryDateLegalProtection),
                roles:                     mappedRoles,
                asset:                     item.asset
                                                ? {
                                                    type: checkString(item.asset.type),
                                                    code: checkString(item.asset.code),
                                                } : {},
            };
        });

        const propertyForeclosures = (lr.propertyForeclosures || []).map((item, idx) => {
            const mappedAmounts = (item.amounts || []).map((aItem, aIdx) => ({
                j:        aIdx,
                amount:   formatNumberWithSpaces(aItem.amount),
                currency: checkString(aItem.currency),
            }));
            return {
                j:                              idx,
                id:                             checkString(item.id),
                legalFoundation:                checkString(item.legalFoundation),
                directResponsibility:           boolToText(item.directResponsibility),
                updatedDate:                    formatYMDtoDMY(item.updatedDate),
                registeredDate:                 formatYMDtoDMY(item.registeredDate),
                registeredOnMultipleProperties: boolToText(item.registeredOnMultipleProperties),
                multipleDefendants:             boolToText(item.asset),
                amounts:                        mappedAmounts,
                claimant:                       item.claimant
                    ? {
                        type:                checkString(item.claimant.type),
                        organisationId:      checkString(item.claimant.organisationId),
                        name:                checkString(item.claimant.name),
                    } : {},
                processRepresentativeAgent: item.processRepresentativeAgent
                    ? {
                        type:                checkString(item.processRepresentativeAgent.type),
                        organisationId:      checkString(item.processRepresentativeAgent.organisationId),
                        name:                checkString(item.processRepresentativeAgent.name),
                    } : {},
            };
        });

         const propertyEnforcedActionRemarks = (lr.propertyEnforcedActionRemarks || []).map((item, idx) => {
            return {
                j:                              idx,
                id:                             checkString(item.id),
                registeredDate:                 formatYMDtoDMY(item.registeredDate),
                registeredOnMultipleProperties: boolToText(item.registeredOnMultipleProperties),
                directResponsibility:           boolToText(item.directResponsibility),
                caseNumber:                     checkString(item.caseNumber),
                legalFoundation:                checkString(item.legalFoundation),
                freeText:                       checkString(item.freeText),
                districtCourt:                  checkString(item.districtCourt),
                estateManager:                  checkString(item.estateManager),
            };
        });

        const financialStatements = (e.financialStatements || []).map((item, idx) => ({
            j:                         idx,
            financialYear:             checkString(item.financialYear),
            parentCompany:             boolToText(item.parentCompany),
            fromDate:                  formatYMDtoDMY(item.fromDate),
            toDate:                    formatYMDtoDMY(item.toDate),
            liquidationAccounts:       boolToText(item.liquidationAccounts),
            presentationPlan:          checkString(item.presentationPlan),
            nonAuditedAnnualReport:    boolToText(item.nonAuditedAnnualReport),
            optedOutOfAudit:           boolToText(item.optedOutOfAudit),
            smallEnterprise:           boolToText(item.smallEnterprise),
            operatingIncome:           formatNumberWithSpaces(item.operatingIncome),
            operatingExpenses:         formatNumberWithSpaces(item.operatingExpenses),
            operatingProfit:           formatNumberWithSpaces(item.operatingProfit),
            financialIncome:           formatNumberWithSpaces(item.financialIncome),
            financialExpenses:         formatNumberWithSpaces(item.financialExpenses),
            netFinancials:             formatNumberWithSpaces(item.netFinancials),
            ordinaryResultBeforeTax:   formatNumberWithSpaces(item.ordinaryResultBeforeTax),
            annualProfit:              formatNumberWithSpaces(item.annualProfit),
            totalProfit:               formatNumberWithSpaces(item.totalProfit),
            fixedAssets:               formatNumberWithSpaces(item.fixedAssets),
            currentAssets:             formatNumberWithSpaces(item.currentAssets),
            totalAssets:               formatNumberWithSpaces(item.totalAssets),
            longTermLiabilities:       formatNumberWithSpaces(item.longTermLiabilities),
            shortTermLiabilities:      formatNumberWithSpaces(item.shortTermLiabilities),
            totalLiabilities:          formatNumberWithSpaces(item.totalLiabilities),
            paidInEquity:              formatNumberWithSpaces(item.paidInEquity),
            earnedEquity:              formatNumberWithSpaces(item.earnedEquity),
            totalEquity:               formatNumberWithSpaces(item.totalEquity),
            totalEquityAndLiabilities: formatNumberWithSpaces(item.totalEquityAndLiabilities),
        }));

        const shares = (e.shares || []).map((item, idx) => ({
            j:                          idx,
            organisationName:           checkString(item.organisationName),
            organisationId:             checkString(item.organisationId),
            shareClass:                 checkString(item.shareClass),
            numberOfOwnedShares:        formatNumberWithSpaces(item.numberOfOwnedShares),
            totalNumberOfCompanyShares: formatNumberWithSpaces(item.totalNumberOfCompanyShares),
            shareOfOwnership:           percentFormatter.format(item.shareOfOwnership),
        }));


        const shareholders = (e.shareholders || []).map((item, idx) => ({
            j:                          idx,
            shareClass:                 checkString(item.shareClass),
            numberOfOwnedShares:        formatNumberWithSpaces(item.numberOfOwnedShares),
            totalNumberOfCompanyShares: formatNumberWithSpaces(item.totalNumberOfCompanyShares),
            shareOfOwnership:           percentFormatter.format(item.shareOfOwnership),
            owner:                      item.owner
                ? {
                    countryCode:        checkString(item.owner.countryCode),
                    name:               checkString(item.owner.name),
                    type:               checkString(item.owner.type)
                } : {}
        }));

        const roles = (e.roles || []).map((item, idx) => ({
            j:              idx,
            code:           checkString(item.code),
            description:    checkString(item.description),
            name:           checkString(item.name),
            birthYear:      formatYMDtoDMY(item.roleHolder.birthDate),
            type:           checkString(item.roleHolder.type),
            organisationId: checkString(item.roleHolder.organisationId),
            name:           formatName(item.roleHolder.name),
        }));

        const properties = (e.properties || []).map((item, idx) => {
            const info = item.info || {};
            const valuation = item.valuation || {};
            const mappedLiens = (item.liens || []).map((lItem, lIdx) => {
                const mappedAmounts = (lItem.amounts || []).map((aItem, aIdx) => ({
                    j:                        aIdx,
                    estimatedRemainingAmount: formatNumberWithSpaces(aItem.estimatedRemainingAmount),
                    amount:                   formatNumberWithSpaces(aItem.amount),
                    currency:                 checkString(aItem.currency),
                }));
                const mappedRightsHolders = (lItem.rightsHolders || []).map((rhItem, rhIdx) => ({
                    j:              rhIdx,
                    type:           checkString(rhItem.type),
                    organisationId: checkString(rhItem.organisationId),
                    name:           checkString(rhItem.name),
                }));

                return {
                    j:                              lIdx,
                    type:                           checkString(lItem.type),
                    id:                             checkString(lItem.id),
                    legalFoundation:                checkString(lItem.legalFoundation),
                    directResponsibility:           boolToText(lItem.directResponsibility),
                    updatedDate:                    formatYMDtoDMY(lItem.updatedDate),
                    registeredDate:                 formatYMDtoDMY(lItem.registeredDate),
                    registeredOnMultipleProperties: boolToText(lItem.registeredOnMultipleProperties),
                    multipleDefendants:             boolToText(lItem.multipleDefendants),
                    amounts:                        mappedAmounts,
                    rightsHolders:                  mappedRightsHolders,
                };
            });

            const mappedOwners = (item.owners || []).map((oItem, oIdx) => ({
                j:                oIdx,
                type:             checkString(oItem.type),
                birthDate:        formatYMDtoDMY(oItem.birthDate),
                organisationId:   checkString(oItem.organisationId),
                name:             checkString(oItem.name),
                shareOfOwnership: percentFormatter.format(oItem.shareOfOwnership),
            }));

            const mappedVoluntaryRemarks = (item.voluntaryRemarks || []).map((vrItem, vrIdx) => ({
                j:                              vrIdx,
                id:                             checkString(vrItem.id),
                registeredDate:                 formatYMDtoDMY(vrItem.registeredDate),
                registeredOnMultipleProperties: boolToText(vrItem.registeredOnMultipleProperties),
                directResponsibility:           boolToText(vrItem.directResponsibility),
                caseNumber:                     checkString(vrItem.caseNumber),
                legalFoundation:                checkString(vrItem.legalFoundation),
                freeText:                       checkString(vrItem.freeText),
                districtCourt:                  checkString(vrItem.districtCourt),
                estateManager:                  checkString(vrItem.estateManager),
            }));


            const mappedEnforcedActionRemarks = (item.enforcedActionRemarks || []).map((eItem, eIdx) => ({
                j:                              eIdx,
                id:                             checkString(eItem.id),
                registeredDate:                 formatYMDtoDMY(eItem.registeredDate),
                registeredOnMultipleProperties: boolToText(eItem.registeredOnMultipleProperties),
                directResponsibility:           boolToText(eItem.directResponsibility),
                caseNumber:                     checkString(eItem.caseNumber),
                legalFoundation:                checkString(eItem.legalFoundation),
                freeText:                       checkString(eItem.freeText),
                districtCourt:                  checkString(eItem.districtCourt),
                estateManager:                  checkString(eItem.estateManager),
            }));

            return {
                j:    idx,
                info: item.info
                ? {
                    address:                          checkString(info.address),
                    addressType:                      checkString(info.addressType),
                    cadastralUnitNumber:              checkString(info.cadastralUnitNumber),
                    externalPropertyInfoUrl:          checkString(info.externalPropertyInfoUrl),
                    housingCooperativeOrganisationId: checkString(info.housingCooperativeOrganisationId),
                    housingCooperativeName:           checkString(info.housingCooperativeName),
                    housingCooperativeShareNumber:    checkString(info.housingCooperativeShareNumber),
                    leaseNumber:                      checkString(info.leaseNumber),
                    municipalityNumber:               checkString(info.municipalityNumber),
                    ownershipRights:                  checkString(info.ownershipRights),
                    postalAddress:                    checkString(info.postalAddress),
                    propertyType:                     checkString(info.propertyType),
                    registerUnitId:                   checkString(info.registerUnitId),
                    sectionNumber:                    checkString(info.sectionNumber),
                    shareOfOwnership:                 percentFormatter.format(info.shareOfOwnership),
                    type:                             checkString(info.type),
                    unitNumber:                       checkString(info.unitNumber),
                    zipCode:                          checkString(info.zipCode),
                } : {},
                valuation: item.valuation 
                ? {
                    estimatedPrice:           formatNumberWithSpaces(valuation.estimatedPrice),
                    estimatedPriceConfidence: checkString(valuation.estimatedPriceConfidence),
                    previousSaleDate:         formatYMDtoDMY(valuation.previousSaleDate),
                    previousSalePrice:        formatNumberWithSpaces(valuation.previousSalePrice),
                    shareOfEstimatedPrice:    formatNumberWithSpaces(valuation.shareOfEstimatedPrice),
                    shareOfPreviousSalePrice: formatNumberWithSpaces(valuation.shareOfPreviousSalePrice),
                } : {},
                liens:                 mappedLiens,
                liensLength:           mappedLiens.length,
                owners:                mappedOwners,
                voluntaryRemarks:      mappedVoluntaryRemarks,
                enforcedActionRemarks: mappedEnforcedActionRemarks
            }
        });

        const vehicles = (e.vehicles || []).map((item, idx) => {
            const info = item.info || {};
            const valuation = item.valuation || {};

            const mappedLiens = (item.liens || []).map((lItem, lIdx) => {
                const mappedAmounts = (lItem.amounts || []).map((aItem, aIdx) => ({
                    j:        aIdx,
                    amount:   formatNumberWithSpaces(aItem.amount),
                    currency: checkString(aItem.currency),
                }));
                const mappedMortagor = (lItem.mortagor || []).map((mItem, mIdx) => ({
                    j:              mIdx,
                    type:           checkString(mItem.type),
                    organisationId: checkString(mItem.organisationId),
                    name:           checkString(mItem.name),
                }));
                const mappedLienHolder = (lItem.lienHolder || []).map((lhItem, lhIdx) => ({
                    j:              lhIdx,
                    type:           checkString(lhItem.type),
                    organisationId: checkString(lhItem.organisationId),
                    name:           checkString(lhItem.name),
                }));

                return {
                    j:                         lIdx,
                    type:                      checkString(lItem.type),
                    documentNumber:            checkString(lItem.documentNumber),
                    entryTimestamp:            checkString(lItem.entryTimestamp),
                    decisionTimestamp:         checkString(lItem.decisionTimestamp),
                    expiryDateLegalProtection: formatYMDtoDMY(lItem.expiryDateLegalProtection),
                    amounts:                   mappedAmounts,
                    mortagor:                  mappedMortagor,
                    lienHolder:                mappedLienHolder,
                };
            });

            return {
                j:    idx,
                info: item.info
                ? {
                    registrationNumber:    checkString(info.registrationNumber),
                    vehicleType:           checkString(info.vehicleType),
                    brand:                 checkString(info.brand),
                    model:                 checkString(info.model),
                    firstRegistrationDate: formatYMDtoDMY(info.firstRegistrationDate),
                    registrationStatus:    checkString(info.registrationStatus),
                } : {},
                valuation: item.valuation 
                ? {
                    estimatedDealerPrice:      formatNumberWithSpaces(valuation.estimatedDealerPrice),
                    estimatedPrivateSalePrice: formatNumberWithSpaces(valuation.estimatedPrivateSalePrice),
                } : {},
                liens:                 mappedLiens,
                liensLength:           mappedLiens.length,
            }
        });

        return {
            i,
            debtorType: 'Næring',
            orgNo: orgNo,
            organisationInformation,
            risk,
            legalRecords: {
                paymentRemarks:                paymentRemarks,
                movableAssets:                 movableAssets,
                propertyForeclosures:          propertyForeclosures,
                propertyEnforcedActionRemarks: propertyEnforcedActionRemarks,
            },
            financialStatements,
            shares,
            shareholders,
            roles,
            properties,
            vehicles,
        };
    })
};


const mapPersonRating = (personRatingObject, birthNo) => {
    if (!personRatingObject) return null;

    const arr = Array.isArray(personRatingObject) ? personRatingObject : [personRatingObject];

    return arr.map((e, i) => {

        const pi = e.personInformation || {};
        const addr = pi.residentialAddress || {};

        const personInformation = {
            firstName:         checkString(pi.firstName),
            lastName:          checkString(pi.lastName),
            name:              checkString(pi.name),
            birthDate:         formatYMDtoDMY(pi.birthDate),
            status:            checkString(pi.status),
            creditFreeze:      boolToText(pi.creditFreeze),
            underGuardianship: boolToText(pi.underGuardianship),
            residentialAddress: pi.residentialAddress 
                ? {
                    municipalityName:   checkString(addr.municipalityName),
                    municipalityNumber: checkString(addr.municipalityNumber),
                    zipCode:            checkString(addr.zipCode),
                    postalArea:         checkString(addr.postalArea),
                    street:             checkString(addr.street),
                    postalAddress:      checkString(addr.postalAddress),
                    poBoxAddress:       checkString(addr.poBoxAddress),
                } : {},
        }

        // risk inneholder legalRecords som inneholder paymentRemarks, movableAssets, propertyForeclosures og propertyEnforcedActionRemarks
        const ri = e.risk || {};
        const su = ri.summary || {};
        const risk = {
            debtCollectionScore:    formatNumber(ri.debtCollectionScore),
            normalisedScore:        formatNumber(ri.normalisedScore),
            scoreRating:            checkString(ri.scoreRating),
            scoreRatingExplanation: checkString(ri.scoreRatingExplanation),
            rawScore:               formatNumber(ri.rawScore),
            probabilityOfDefault:   percentFormatter.format(ri.probabilityOfDefault),
            creditLimit:            formatNumberWithSpaces(ri.creditLimit),
            summary: ri.summary
                ? {
                    ownsVehicle:                     boolToText(su.ownsVehicle),
                    ownsHome:                        boolToText(su.ownsHome),
                    soleProprietor:                  boolToText(su.soleProprietor),
                    majorityOwnerCorporation:        boolToText(su.majorityOwnerCorporation),
                    numberOfCEOroles:                formatNumber(su.numberOfCEOroles),
                    numberOfChairmanRoles:           formatNumber(su.numberOfChairmanRoles),
                    numberOfBoardMemberRoles:        formatNumber(su.numberOfBoardMemberRoles),
                    paymentRemarksCount:             formatNumber(su.paymentRemarksCount),
                    paymentRemarksAmount:            formatNumberWithSpaces(su.paymentRemarksAmount),
                    assetSeizureCount:               formatNumber(su.assetSeizureCount),
                    assetSeizureAmount:              formatNumberWithSpaces(su.assetSeizureAmount),
                    propertyForeclosureCount:        formatNumber(su.propertyForeclosureCount),
                    propertyForeclosureAmount:       formatNumberWithSpaces(su.propertyForeclosureAmount),
                    forcedPropertySaleDecidedCount:  formatNumber(su.forcedPropertySaleDecidedCount),
                    arrestCount:                     formatNumber(su.arrestCount),
                    arrestAmount:                    formatNumberWithSpaces(su.arrestAmount),
                    debtRestructuringOpenedCount:    formatNumber(su.debtRestructuringOpenedCount),
                    debtRestructuringVoluntaryCount: formatNumber(su.debtRestructuringVoluntaryCount),
                    debtRestructuringForcedCount:    formatNumber(su.debtRestructuringForcedCount),
                    noAssetsForSeizureCount:         formatNumber(su.noAssetsForSeizureCount),
                } : {}
        }

        const lr = ri.legalRecords || {};
        const paymentRemarks = (lr.paymentRemarks || []).map((item, idx) => ({
            j:                idx,
            creditor:         checkString(item.creditor),
            caseNumber:       checkString(item.caseNumber),
            registrationDate: formatYMDtoDMY(item.registrationDate),
            settlementStatus: checkString(item.settlementStatus),
            settlementDate:   formatYMDtoDMY(item.settlementDate),
            collectionAgency: checkString(item.collectionAgency),
            typeCode:         checkString(item.typeCode),
            typeDescription:  checkString(item.typeDescription),
            caseEventType:    checkString(item.caseEventType),
            amount:           formatNumberWithSpaces(item.amount),
        }));

        const salaryDeductions = (lr.salaryDeductions || []).map((item, idx) => {
            return {
                j:                    idx,
                caseNumber:           checkString(item.caseNumber),
                monthlyAmount:        formatNumberWithSpaces(item.monthlyAmount),
                startDate:            formatYMDtoDMY(item.startDate),
                endDate:              formatYMDtoDMY(item.endDate),
                hearingHeld:          checkString(item.hearingHeld),
                enforcementAuthority: item.enforcementAuthority
                ? {
                    organisationId: checkString(item.enforcementAuthority.organisationId),
                    name:           checkString(item.enforcementAuthority.name),
                }
                : {},
                claimant:                item.claimant
                ? {
                    type:                checkString(item.claimant.type),
                    organisationId:      checkString(item.claimant.organisationId),
                    name:                checkString(item.claimant.name),
                } : {},
                processRepresentativeAgent: item.processRepresentativeAgent
                ? {
                    type:                checkString(item.processRepresentativeAgent.type),
                    organisationId:      checkString(item.processRepresentativeAgent.organisationId),
                    name:                checkString(item.processRepresentativeAgent.name),
                } : {},
            };
        });

        const noAssetsForSeizure = (lr.noAssetsForSeizure || []).map((item, idx) => {
            return {
                j:                    idx,
                caseNumber:           checkString(item.caseNumber),
                hearingHeld:          checkString(item.hearingHeld),
                enforcementAuthority: item.enforcementAuthority
                ? {
                    organisationId: checkString(item.enforcementAuthority.organisationId),
                    name:           checkString(item.enforcementAuthority.name),
                }
                : {},
                claimant:                   item.claimant
                ? {
                    type:                checkString(item.claimant.type),
                    organisationId:      checkString(item.claimant.organisationId),
                    name:                checkString(item.claimant.name),
                } : {},
                processRepresentativeAgent: item.processRepresentativeAgent
                ? {
                    type:                checkString(item.processRepresentativeAgent.type),
                    organisationId:      checkString(item.processRepresentativeAgent.organisationId),
                    name:                checkString(item.processRepresentativeAgent.name),
                } : {},
            };
        });

        const movableAssets = (lr.movableAssets || []).map((item, idx) => {
            const mappedRoles = (item.roles || []).map((rItem, rIdx) => ({
                j:           rIdx,
                code:        checkString(rItem.code),
                description: checkString(rItem.description),
                roleHolder:  rItem.roleHolder
                    ? {
                        type:           checkString(rItem.roleHolder.type),
                        organisationId: checkString(rItem.roleHolder.organisationId),
                        name:           checkString(rItem.roleHolder.name),
                    } : {}
            }));

            return {
                j:                         idx,
                documentNumber:            checkString(item.documentNumber),
                enforced:                  boolToText(item.enforced),
                expiryDateLegalProtection: formatYMDtoDMY(item.expiryDateLegalProtection),
                roles:                     mappedRoles,
                asset:                     item.asset
                                                ? {
                                                    type: checkString(item.asset.type),
                                                    code: checkString(item.asset.code),
                                                } : {},
            };
        });

        const propertyForeclosures = (lr.propertyForeclosures || []).map((item, idx) => {
            const mappedAmounts = (item.amounts || []).map((aItem, aIdx) => ({
                j:        aIdx,
                amount:   formatNumberWithSpaces(aItem.amount),
                currency: checkString(aItem.currency),
            }));
            return {
                j:                              idx,
                id:                             checkString(item.id),
                legalFoundation:                checkString(item.legalFoundation),
                directResponsibility:           boolToText(item.directResponsibility),
                updatedDate:                    formatYMDtoDMY(item.updatedDate),
                registeredDate:                 formatYMDtoDMY(item.registeredDate),
                registeredOnMultipleProperties: boolToText(item.registeredOnMultipleProperties),
                multipleDefendants:             boolToText(item.asset),
                amounts:                        mappedAmounts,
                claimant:                       item.claimant
                    ? {
                        type:                checkString(item.claimant.type),
                        organisationId:      checkString(item.claimant.organisationId),
                        name:                checkString(item.claimant.name),
                    } : {},
                processRepresentativeAgent: item.processRepresentativeAgent
                    ? {
                        type:                checkString(item.processRepresentativeAgent.type),
                        organisationId:      checkString(item.processRepresentativeAgent.organisationId),
                        name:                checkString(item.processRepresentativeAgent.name),
                    } : {},
            };
        });

         const propertyEnforcedActionRemarks = (lr.propertyEnforcedActionRemarks || []).map((item, idx) => {
            return {
                j:                              idx,
                id:                             checkString(item.id),
                registeredDate:                 formatYMDtoDMY(item.registeredDate),
                registeredOnMultipleProperties: boolToText(item.registeredOnMultipleProperties),
                directResponsibility:           boolToText(item.directResponsibility),
                caseNumber:                     checkString(item.caseNumber),
                legalFoundation:                checkString(item.legalFoundation),
                freeText:                       checkString(item.freeText),
                districtCourt:                  checkString(item.districtCourt),
                estateManager:                  checkString(item.estateManager),
            };
        });

        const incomeStatements = (e.incomeStatements || []).map((item, idx) => ({
            j:                idx,
            taxYear:   checkString(item.taxYear),
            taxClass:  checkString(item.taxClass),
            netIncome: formatNumberWithSpaces(item.netIncome),
            netWealth: formatNumberWithSpaces(item.netWealth),
            tax:       formatNumberWithSpaces(item.tax),
        }));

        const roles = (e.roles || []).map((item, idx) => ({
            j:                idx,
            code:             checkString(item.code),
            description:      checkString(item.description),
            organisationName: checkString(item.organisationName),
            organisationId:   checkString(item.organisationId),
            dagligLeder:      item.code === 'DAGL' ? 'Ja' : '-',
            styreleder:       item.code === 'LEDE' ? 'Ja' : '-',
            styremedlem:      item.code === 'MEDL' ? 'Ja' : '-',
            nestleder:        item.code === 'NEST' ? 'Ja' : '-',
        }));

        const shares = (e.shares || []).map((item, idx) => ({
            j:                          idx,
            organisationName:           checkString(item.organisationName),
            organisationId:             checkString(item.organisationId),
            shareClass:                 checkString(item.shareClass),
            numberOfOwnedShares:        formatNumberWithSpaces(item.numberOfOwnedShares),
            totalNumberOfCompanyShares: formatNumberWithSpaces(item.totalNumberOfCompanyShares),
            shareOfOwnership:           percentFormatter.format(item.shareOfOwnership),
        }));
    
        
        const properties = (e.properties || []).map((item, idx) => {
            const info = item.info || {};
            const valuation = item.valuation || {};

            const mappedLiens = (item.liens || []).map((lItem, lIdx) => {
                const mappedAmounts = (lItem.amounts || []).map((aItem, aIdx) => ({
                    j:                        aIdx,
                    estimatedRemainingAmount: formatNumberWithSpaces(aItem.estimatedRemainingAmount),
                    amount:                   formatNumberWithSpaces(aItem.amount),
                    currency:                 checkString(aItem.currency),
                }));
                const mappedRightsHolders = (lItem.rightsHolders || []).map((rhItem, rhIdx) => ({
                    j:              rhIdx,
                    type:           checkString(rhItem.type),
                    organisationId: checkString(rhItem.organisationId),
                    name:           checkString(rhItem.name),
                }));

                return {
                    j:                              lIdx,
                    type:                           checkString(lItem.type),
                    id:                             checkString(lItem.id),
                    legalFoundation:                checkString(lItem.legalFoundation),
                    directResponsibility:           boolToText(lItem.directResponsibility),
                    updatedDate:                    formatYMDtoDMY(lItem.updatedDate),
                    registeredDate:                 formatYMDtoDMY(lItem.registeredDate),
                    registeredOnMultipleProperties: boolToText(lItem.registeredOnMultipleProperties),
                    multipleDefendants:             boolToText(lItem.multipleDefendants),
                    amounts:                        mappedAmounts,
                    rightsHolders:                  mappedRightsHolders,
                };
            });

            const mappedOwners = (item.owners || []).map((oItem, oIdx) => ({
                j:                oIdx,
                type:             checkString(oItem.type),
                birthDate:        formatYMDtoDMY(oItem.birthDate),
                organisationId:   checkString(oItem.organisationId),
                name:             checkString(oItem.name),
                shareOfOwnership: percentFormatter.format(oItem.shareOfOwnership),
            }));

            const mappedVoluntaryRemarks = (item.voluntaryRemarks || []).map((vrItem, vrIdx) => ({
                j:                              vrIdx,
                id:                             checkString(vrItem.id),
                registeredDate:                 formatYMDtoDMY(vrItem.registeredDate),
                registeredOnMultipleProperties: boolToText(vrItem.registeredOnMultipleProperties),
                directResponsibility:           boolToText(vrItem.directResponsibility),
                caseNumber:                     checkString(vrItem.caseNumber),
                legalFoundation:                checkString(vrItem.legalFoundation),
                freeText:                       checkString(vrItem.freeText),
                districtCourt:                  checkString(vrItem.districtCourt),
                estateManager:                  checkString(vrItem.estateManager),
            }));


            const mappedEnforcedActionRemarks = (item.enforcedActionRemarks || []).map((eItem, eIdx) => ({
                j:                              eIdx,
                id:                             checkString(eItem.id),
                registeredDate:                 formatYMDtoDMY(eItem.registeredDate),
                registeredOnMultipleProperties: boolToText(eItem.registeredOnMultipleProperties),
                directResponsibility:           boolToText(eItem.directResponsibility),
                caseNumber:                     checkString(eItem.caseNumber),
                legalFoundation:                checkString(eItem.legalFoundation),
                freeText:                       checkString(eItem.freeText),
                districtCourt:                  checkString(eItem.districtCourt),
                estateManager:                  checkString(eItem.estateManager),
            }));

            return {
                j:    idx,
                info: item.info
                ? {
                    address:                          checkString(info.address),
                    addressType:                      checkString(info.addressType),
                    cadastralUnitNumber:              checkString(info.cadastralUnitNumber),
                    externalPropertyInfoUrl:          checkString(info.externalPropertyInfoUrl),
                    housingCooperativeOrganisationId: checkString(info.housingCooperativeOrganisationId),
                    housingCooperativeName:           checkString(info.housingCooperativeName),
                    housingCooperativeShareNumber:    checkString(info.housingCooperativeShareNumber),
                    leaseNumber:                      checkString(info.leaseNumber),
                    municipalityNumber:               checkString(info.municipalityNumber),
                    ownershipRights:                  checkString(info.ownershipRights),
                    postalAddress:                    checkString(info.postalAddress),
                    propertyType:                     checkString(info.propertyType),
                    registerUnitId:                   checkString(info.registerUnitId),
                    sectionNumber:                    checkString(info.sectionNumber),
                    shareOfOwnership:                 percentFormatter.format(info.shareOfOwnership),
                    type:                             checkString(info.type),
                    unitNumber:                       checkString(info.unitNumber),
                    zipCode:                          checkString(info.zipCode),
                } : {},
                valuation: item.valuation 
                ? {
                    estimatedPrice:           formatNumberWithSpaces(valuation.estimatedPrice),
                    estimatedPriceConfidence: checkString(valuation.estimatedPriceConfidence),
                    previousSaleDate:         formatYMDtoDMY(valuation.previousSaleDate),
                    previousSalePrice:        formatNumberWithSpaces(valuation.previousSalePrice),
                    shareOfEstimatedPrice:    formatNumberWithSpaces(valuation.shareOfEstimatedPrice),
                    shareOfPreviousSalePrice: formatNumberWithSpaces(valuation.shareOfPreviousSalePrice),
                } : {},
                liens:                 mappedLiens,
                liensLength:           mappedLiens.length,
                owners:                mappedOwners,
                voluntaryRemarks:      mappedVoluntaryRemarks,
                enforcedActionRemarks: mappedEnforcedActionRemarks
            }
        });

        const vehicles = (e.vehicles || []).map((item, idx) => {
            const info = item.info || {};
            const valuation = item.valuation || {};

            const mappedLiens = (item.liens || []).map((lItem, lIdx) => {
                const mappedAmounts = (lItem.amounts || []).map((aItem, aIdx) => ({
                    j:        aIdx,
                    amount:   formatNumberWithSpaces(aItem.amount),
                    currency: checkString(aItem.currency),
                }));
                const mappedMortagor = (lItem.mortagor || []).map((mItem, mIdx) => ({
                    j:              mIdx,
                    type:           checkString(mItem.type),
                    organisationId: checkString(mItem.organisationId),
                    name:           checkString(mItem.name),
                }));
                const mappedLienHolder = (lItem.lienHolder || []).map((lhItem, lhIdx) => ({
                    j:              lhIdx,
                    type:           checkString(lhItem.type),
                    organisationId: checkString(lhItem.organisationId),
                    name:           checkString(lhItem.name),
                }));

                return {
                    j:                         lIdx,
                    type:                      checkString(lItem.type),
                    documentNumber:            checkString(lItem.documentNumber),
                    entryTimestamp:            checkString(lItem.entryTimestamp),
                    decisionTimestamp:         checkString(lItem.decisionTimestamp),
                    expiryDateLegalProtection: formatYMDtoDMY(lItem.expiryDateLegalProtection),
                    amounts:                   mappedAmounts,
                    mortagor:                  mappedMortagor,
                    lienHolder:                mappedLienHolder,
                };
            });

            return {
                j:    idx,
                info: item.info
                ? {
                    registrationNumber:    checkString(info.registrationNumber),
                    vehicleType:           checkString(info.vehicleType),
                    brand:                 checkString(info.brand),
                    model:                 checkString(info.model),
                    firstRegistrationDate: formatYMDtoDMY(info.firstRegistrationDate),
                    registrationStatus:    checkString(info.registrationStatus),
                } : {},
                valuation: item.valuation 
                ? {
                    estimatedDealerPrice:      formatNumberWithSpaces(valuation.estimatedDealerPrice),
                    estimatedPrivateSalePrice: formatNumberWithSpaces(valuation.estimatedPrivateSalePrice),
                } : {},
                liens:                 mappedLiens,
                liensLength:           mappedLiens.length,
            }
        });


        return {
            i,
            debtorType: 'Privat',
            birthNo: birthNo,
            personInformation,
            risk,
            legalRecords: {
                paymentRemarks:                paymentRemarks,
                salaryDeductions:              salaryDeductions,
                noAssetsForSeizure:            noAssetsForSeizure,
                movableAssets:                 movableAssets,
                propertyForeclosures:          propertyForeclosures,
                propertyEnforcedActionRemarks: propertyEnforcedActionRemarks,
            },
            incomeStatements,
            roles,
            shares,
            properties,
            vehicles
        };
    })
};

const mapRatingInfo = (ratingInfoObject) => {
    if (!ratingInfoObject) {
        return null;
    }

    if (!Array.isArray(ratingInfoObject)) {
        ratingInfoObject = [ratingInfoObject];
    }

    const uCase = (e, fieldName) => {
        if (e.hasOwnProperty(fieldName)) {
            let val = e[fieldName]
            if (val) {
                return val.toUpperCase()
            }
        }
        return ''
    }

    return ratingInfoObject.map((e, i) => {
        const item = {
            i: i,
            billingEmail: e.billingEmail,
            bislabCustomerId: e.bislabCustomerId,
            contactEmail: e.contactEmail,
            contactPhone: e.contactPhone,
            createdDate: formatDate(e.createdDate),
            enabled: e.enabled,
            kfCustomerNo: e.kfCustomerNo,
            orgno: e.orgno,
            partnerCustomerId: e.partnerCustomerId,
            termsId: e.termsId,
            bislabLogCollection: [...e.bislabLogCollection],   
            bislabTransactionsCollection: e.bislabTransactionsCollection.map((f, j) => {
                let parsedJson = {};

                try {
                    parsedJson = f.bislabJson ? JSON.parse(f.bislabJson) : {};
                    parsedJson.innehaverEnk = boolToText(parsedJson.innehaverEnk);
                    // Formatterer noen verdier
                    parsedJson = processParsedJsonToBool(parsedJson);

                    if (parsedJson?.personInformation?.firstName) {
                        // Lager fullt navn da den ikke kommer med i json objektet av en eller annen grunn
                        parsedJson.personInformation.name = parsedJson.personInformation.firstName + " " + parsedJson.personInformation.lastName;
                    }
                    // Gamle søk har norske felter
                    if (parsedJson.fornavn) {
                        // Lager fullt navn da den ikke kommer med i json objektet av en eller annen grunn
                        parsedJson.navn = parsedJson.fornavn + " " + parsedJson.etternavn;
                    }
                    if (Array.isArray(parsedJson.roles)) {
                        if (parsedJson.personInformation) {
                            parsedJson.roles = parsedJson.roles.map(role => ({
                                code:             role.code,
                                description:      role.description,
                                organisationName: role.organisationName,
                                organisationId:   role.organisationId,
                                dagligLeder:      role.code === 'DAGL' ? 'Ja' : '-',
                                styreleder:       role.code === 'LEDE' ? 'Ja' : '-',
                                styremedlem:      role.code === 'MEDL' ? 'Ja' : '-',
                                nestleder:        role.code === 'NEST' ? 'Ja' : '-',
                            }));
                        } else {
                            parsedJson.roles = parsedJson.roles.map(role => ({
                                code:           role.code,
                                description:    role.description,
                                name:           formatName(role.roleHolder?.name),
                                birthYear:      role.roleHolder?.birthDate,
                                type:           role.roleHolder?.type,
                                organisationId: role.roleHolder?.organisationId,
                                dagligLeder:    role.code === 'DAGL' ? 'Ja' : '-',
                                styreleder:     role.code === 'LEDE' ? 'Ja' : '-',
                                styremedlem:    role.code === 'MEDL' ? 'Ja' : '-',
                                nestleder:      role.code === 'NEST' ? 'Ja' : '-',
                            }));
                        }
                    }

                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    parsedJson = {};
                }

                return {
                    j: j,
                    bislabTransactionId: f.bislabTransactionId,
                    emailUser: f.emailUser,
                    noSearch: f.noSerach,
                    price: f.price,
                    transactionDate: f.transactionDate,
                    searchType: setSearchType(f.searchType),
                    newVersion: checkVersion(f.searchType),
                    searchTerm: f.searchTerm,
                    bislabJson: parsedJson,
                    searchIndex: `${formatDate(f.transactionDate)};${setSearchType(f.searchType)};${uCase(f, 'emailUser')};${f.searchTerm};`,
                    bislabLogList: f.bislabLogList.map((g, k) => {
                        return {
                            k: k,
                            action: setAction(g.action),
                            bislabLogId: g.bislabLogId,
                            email: g.email,
                            regDate: formatDate(g.regdate),
                        }
                    })
                }
            })
        }
    return item
})
    
}


export const companyRatingFailure = error => ({
    type: actions.RATING_ERROR,
    data: { error }
});


export const companyRatingFetched = data => ({
    type: actions.COMPANY_RATING_FETCHED,
    data: data
})

export const personRatingFailure = error => ({
    type: actions.RATING_ERROR,
    data: { error }
});


export const personRatingFetched = data => ({
    type: actions.PERSON_RATING_FETCHED,
    data: data
})

export const ratingInfoFailure = error => ({
    type: actions.CREDIT_RATING_ERROR,
    data: { error }
});

export const creditRatingTermsFailure = error => ({
    type: actions.CREDIT_RATING_ERROR,
    data: { error }
});

export const creditRatingTermsFetched = data => ({
    type: actions.CREDIT_RATING_TERMS_FETCHED,
    data: data
})

export const updateDebtorRatingFailure = error => ({
    type: actions.CREDIT_RATING_ERROR,
    data: { error }
});

export const clearData = () => {
    return dispatch => {
        dispatch({ type: actions.CREDIT_RATING_DATA_CLEAR, payload: null })
    }
}

export const clearRatingData = () => {
    return dispatch => {
        dispatch({ type: actions.CREDIT_RATING_DATA_CLEAR_RATING, payload: null })
    }
}

export const setKredittvurderingFilterString = (filterString) => {
    return dispatch => {
        dispatch({ type: actions.CREDIT_RATING_SET_SOKEVERDI, payload: { value: filterString } })
    }
}

export const getCompanyRating = (creditorNo, orgNo, emailUser, debtorNo, showToasts, messages) => {
    return dispatch => {
        return getCompanyRatingDispatcher(dispatch, creditorNo, orgNo, emailUser, debtorNo, showToasts, messages)
    }
}

export const getPersonRating = (creditorNo, personalIdentificationNumber, emailUser, debtorNo, showToasts, messages) => {
    return dispatch => {
        return getPersonRatingDispatcher(dispatch, creditorNo, personalIdentificationNumber, emailUser, debtorNo, showToasts, messages)
    }
}

export const getRatingInfo = (creditorNo, showToasts, messages, refreshList) => {
    return dispatch => {
        getRatingInfoDispatcher(dispatch, creditorNo, showToasts, messages, refreshList)
    }
}

export const getBislabCurrentTerms = (showToasts, messages) => {
    return dispatch => {
        getBislabCurrentTermsDispatcher(dispatch, showToasts, messages)
    }
}

export const updateDebtorRating = (formData, debtorNo, showToasts, messages) => {
    return dispatch => {
        updateDebtorRatingDispatcher(dispatch, formData, debtorNo, showToasts, messages)
    }
}

export const acceptCreditRating = (formData, creditorNo, showToasts, messages) => {
    return dispatch => {
        return acceptCreditRatingDispatcher(dispatch, formData, creditorNo, showToasts, messages)
    }
}

export const disableRating = (formData, creditorNo, showToasts, messages) => {
    return dispatch => {
        return disableRatingispatcher(dispatch, formData, creditorNo, showToasts, messages)
    }
}


const getCompanyRatingDispatcher = (dispatch, creditorNo, orgNo, emailUser, debtorNo, showToasts, messages) => {
        dispatch({ type: actions.OVERLAY_RATING_LOADING})
        dispatch({ type: actions.CREDIT_RATING_DATA_CLEAR_RATING, payload: null })


        if (creditorNo === '') {
            return
        }

       return axiosTokenInstance
            ({
                method: 'GET',
                url: `/api/Kredittvurdering/getCreditRatingCompany/${creditorNo}/${orgNo}/${emailUser}/${debtorNo}`,
            })
            .then((result) => {
                dispatch({ type: actions.OVERLAY_RATING_CLEAR_LOADING})
                if (result.status !== 200) {
                    (showToasts && toast.error(messages['toastGetCompanyRatingFailed'], { autoClose: false }))
                    dispatch(companyRatingFailure(messages['toastGetCompanyRatingFailed']))
                    return null;
                } else {
                    const data = result.data
                    if (data.status.errorCode === 0) {
                        (showToasts && toast.warning(messages['toastGetCompanyRatingOk'] + orgNo))
                        dispatch({ type: actions.COMPANY_RATING_FETCHED, payload: { ratingData: mapCompanyRating(data.companyRatingV2, orgNo) }})
                        return mapCompanyRating(data.companyRatingV2, orgNo);
                    } else if (data.status.errorCode === 200) {
                        (showToasts && toast.error(messages['toastGetCompanyRatingFailed'] + 'Sjekk om orgummer ' + orgNo + ' er korrekt.', { autoClose: true }))
                        dispatch(companyRatingFailure(messages['toastGetCompanyRatingFailed']))
                        return null;
                    } else {
                        (showToasts && toast.error(messages['toastGetCompanyRatingFailed'] + 'Sjekk om orgummer ' + orgNo + ' er korrekt.', { autoClose: true }))
                        dispatch(companyRatingFailure(messages['toastGetCompanyRatingFailed']))
                        return null;
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: actions.OVERLAY_RATING_CLEAR_LOADING })
                let errormessage = `Noe gikk galt ved henting av kredittvurdering av ${orgNo}.` + getErrorMessage(err)
                toast.error(errormessage, { autoClose: false })
                dispatch(companyRatingFailure(errormessage))
                return null;
            })
    }

const getPersonRatingDispatcher = (dispatch, creditorNo, personalIdentificationNumber, emailUser, debtorNo, showToasts, messages) => {
        dispatch({ type: actions.OVERLAY_RATING_LOADING })
        dispatch({ type: actions.CREDIT_RATING_DATA_CLEAR_RATING, payload: null })

        if (creditorNo === '') {
            return
        }

         return axiosTokenInstance
            ({
                method: 'GET',
                url: `/api/Kredittvurdering/getCreditRatingPerson/${creditorNo}/${personalIdentificationNumber}/${emailUser}/${debtorNo}`,
            })
            .then((result) => {
                dispatch({ type: actions.OVERLAY_RATING_CLEAR_LOADING })
                if (result.status !== 200) {
                    (showToasts && toast.error(messages['toastGetPersonRatingFailed'], { autoClose: false }))
                    dispatch(personRatingFailure(messages['toastGetPersonRatingFailed']))
                    return null;
                } else {
                    const data = result.data

                    if (data.status.errorCode === 0) {
                        (showToasts && toast.warning(messages['toastGetPersonRatingOk'] + personalIdentificationNumber))
                        dispatch({ type: actions.PERSON_RATING_FETCHED, payload: { ratingData: mapPersonRating(data.privateRatingV2, personalIdentificationNumber) } })
                        return mapPersonRating(data.privateRatingV2, personalIdentificationNumber)
                    } else {
                        (showToasts && toast.error(messages['toastGetPersonRatingFailed']  + personalIdentificationNumber + ' er korrekt.', { autoClose: true }))
                        dispatch(personRatingFailure(messages['toastGetPersonRatingFailed']))
                        return null;
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: actions.OVERLAY_RATING_CLEAR_LOADING })
                let errormessage = `Noe gikk galt ved henting av kredittvurdering av ${personalIdentificationNumber}.` + getErrorMessage(err)
                toast.error(errormessage, { autoClose: false })
                dispatch(personRatingFailure(errormessage))
                return null;
            })
}

const getRatingInfoDispatcher = (dispatch, creditorNo, showToasts, messages, refreshList) => {

    dispatch({ type: actions.CREDIT_RATING_LOADING, data: null })

        if (creditorNo === '') {
            return
        }

        axiosTokenInstance
            ({
                method: 'GET',
                url: `/api/Kredittvurdering/doGetRatingInfo/${creditorNo}`,
            })
            .then((result) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })
                if (result.status !== 200) {
                    (showToasts && toast.error(messages['toastGetRatingInfoFailed'], { autoClose: false }))
                    dispatch(ratingInfoFailure(messages['toastGetRatingInfoFailed']))
                } else {
                    const data = result.data
                    if (data.errorCode === 0) {
                        if (!data.customer.enabled) {
                            (showToasts && toast.warning(messages['toastGetRatingInfoNoGo'], { autoClose: true }))
                            dispatch(ratingInfoFailure(messages['toastGetRatingInfoNoGo']))
                        }
                        (showToasts && toast.warning(messages[refreshList ? 'toastGetRatingInfoRefreshOk' : 'toastGetRatingInfoOk']))
                        dispatch({ type: actions.RATING_INFO_FETCHED, payload: { searchHistoryData: mapRatingInfo(data.customer), fetchedData: data } })
                    } else if (data.errorCode === 300) {
                        (showToasts && toast.warning(messages['toastGetRatingInfoNoOrgNr'], { autoClose: true }))
                        dispatch(ratingInfoFailure(messages['toastGetRatingInfoNoOrgNr']))
                    } else {
                        (showToasts && toast.error(messages['toastGetRatingInfoFailed'], { autoClose: false }))
                        dispatch(ratingInfoFailure(messages['toastGetRatingInfoFailed']))
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })
                console.log(err)
                let errormessage = getErrorMessage(err) + ` (/api/CreditRating/doGetRatingInfo/${creditorNo})`
                toast.error(errormessage, { autoClose: false })
                dispatch(ratingInfoFailure(errormessage))
            })
}

const getBislabCurrentTermsDispatcher = (dispatch, showToasts, messages) => {
        // dispatch({ type: actions.CREDIT_RATING_LOADING, data: null })

        axiosTokenInstance({
            method: 'GET',
            url: `/api/Kredittvurdering/getBislabCurrentTerms`,
        })
            .then((result) => {
                // dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })
                if (result.status !== 200) {
                    (showToasts && toast.error(messages['toastGetBislabTermsFailed'], { autoClose: false }));
                    dispatch(creditRatingTermsFailure(messages['toastGetBislabTermsFailed']));
                } else {
                    const data = result.data;
                    if (data.base64 !== null) {
                        (showToasts && toast.warning(messages['toastGetBislabTermsOk']));
                        dispatch({ type: actions.CREDIT_RATING_TERMS_FETCHED, payload: { fetchedData: data.base64 } })

                    } else {
                        (showToasts && toast.warning(messages['toastGetBislabTermsFailed'] + ', ' + result.data.errorMessage));
                        dispatch(creditRatingTermsFailure(messages['toastGetBislabTermsFailed']));
                    }
                }
            })
            .catch((err) => {
                // dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })
                let errormessage = getErrorMessage(err) + ` (/api/CreditRating/getBislabCurrentTerms)`;
                toast.error(errormessage, { autoClose: false });
                dispatch(creditRatingTermsFailure(errormessage));
            });
}


const updateDebtorRatingDispatcher = (dispatch, formData, debtorNo, showToasts, messages) => {

    const okMessage = messages['toastUpdateDebtorRatingOk']

    dispatch({ type: actions.CREDIT_RATING_LOADING, data: null })

        axiosTokenInstance
            ({
                method: 'POST',
                url: `/api/Kredittvurdering/updateRating`,
                data: formData
            })
            .then((result) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })

                if (result.status !== 200) {

                    (showToasts && toast.error(messages['toastUpdateDebtorRatingFailed'], { autoClose: false }))

                } else {

                    if (result.data) {

                        (showToasts && toast.info(okMessage + debtorNo))

                    } else {
                        (showToasts && toast.warning(messages['toastUpdateDebtorRatingFailed'] + ', ' + + ', ' + result.data.errorMessage))
                        //dispatch({ type: actions.ERROR, data: messages['toastNySakPostDebitorFailed'] + + ', ' + result.data.errorMessage })
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })

                let errormessage = getErrorMessage(err)
                toast.error(errormessage, { autoClose: false })
                //dispatch({ type: actions.ERROR, data: errormessage })
                dispatch(updateDebtorRatingFailure(messages['toastUpdateDebtorRatingFailed']))
                console.log(err)
            })
}

const acceptCreditRatingDispatcher = (dispatch, formData, creditorNo, showToasts, messages) => {

    dispatch({ type: actions.CREDIT_RATING_LOADING, data: null })

         return axiosTokenInstance
            ({
                method: 'POST',
                url: `/api/Kredittvurdering/doAcceptCreditRating`,
                data: formData
            })
            .then((result) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })

                if (result.status !== 200) {
                    (showToasts && toast.error(messages['toastAcceptRatingFailed'] + formData.get("email"), { autoClose: false }))
                    return false;
                } else {
                    if (result.data.errorCode === 110) {
                        (showToasts && toast.warning(result.data.status + ', avtale signert for bruker ' + formData.get("email"), { autoClose: true }))
                        dispatch({ type: actions.TERMS_ACCEPTED_SUCCESSFULLY })
                        return true;
                    }

                    if (result.data.errorCode === 100) {
                        (showToasts && toast.error(result.data.status, { autoClose: true }))
                        return false;
                    }

                    if (result.data.errorCode === 200) {
                        (showToasts && toast.error(result.data.status, { autoClose: false }))
                        return false;
                    }

                    if (result.data.errorCode === 0) {
                        (showToasts && toast.warning(messages['toastAcceptRatingOk'] + formData.get("email") + ' og for kreditor ' + creditorNo))
                        dispatch({ type: actions.TERMS_ACCEPTED_SUCCESSFULLY })
                        return true;
                    } else {
                        (showToasts && toast.error(messages['toastAcceptRatingFailed'] + formData.get("email") + + ', ' + result.data.errorMessage))
                        return false;
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })
                let errorMessage = err.message;
                toast.error(errorMessage, { autoClose: false })
            })
}

const disableRatingispatcher = async (dispatch, formData, creditorNo, showToasts, messages) => {

    const deactivateKreditor = formData.get("deactivateKreditor");
    const okMessage = messages[deactivateKreditor ? 'toastDeactivateDebtorRatingOk' : 'toastDeactivateUserRatingOk']

    dispatch({ type: actions.CREDIT_RATING_LOADING, data: null })

        return axiosTokenInstance
            ({
                method: 'POST',
                url: `/api/Kredittvurdering/disableRating`,
                data: formData
            })
            .then((result) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })

                if (result.status !== 200) {
                    (showToasts && toast.error(messages[deactivateKreditor ? 'toastDeactivateDebtorRatingFailed' : 'toastDeactivateUserRatingFailed'], { autoClose: false }))
                    return null;
                } else {
                    if (result.data === 'OK') {
                        (showToasts && toast.info(okMessage + creditorNo))
                        return 'disabled';
                    } else {
                        (showToasts && toast.warning(messages[deactivateKreditor ? 'toastDeactivateDebtorRatingFailed' : 'toastDeactivateUserRatingFailed'] + ', ' + + ', ' + result.data.errorMessage))
                        return null;
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: actions.CREDIT_RATING_CLEAR_LOADING, data: null })
                let errormessage = getErrorMessage(err)
                toast.error(errormessage, { autoClose: false })
                dispatch(updateDebtorRatingFailure(messages[deactivateKreditor ? 'toastDeactivateDebtorRatingFailed' : 'toastDeactivateUserRatingFailed']))
                console.log(err)
            })
}